import classNames from 'classnames'

import { useLanguage } from '../../../context/LangaugeContextProvider/LangaugeContextProvider'
import { isArabic } from '../../../utils'
import styles from './AnimatedCard.module.scss'

function AnimatedCard({
  children,
  renderTopAnimation,
  renderBottomAnimation,
  cardClassname,
  bottomAnimationClassName,
  topAnimationClassName,
}) {
  const { language } = useLanguage()
  return (
    <div
      className={classNames(
        'w-full h-full relative overflow-hidden',
        styles['card-container'],
        cardClassname
      )}
    >
      {renderTopAnimation && (
        <SlideAnimation
          className={classNames(styles['top-container'], topAnimationClassName)}
          bottomHover={false}
          topHover={true}
          animationWrapper={false}
          language={language}
        >
          {renderTopAnimation()}
        </SlideAnimation>
      )}
      {children}
      {renderBottomAnimation && (
        <>
          <SlideAnimation
            className={classNames(bottomAnimationClassName)}
            bottomHover={true}
            topHover={false}
            animationWrapper={true}
            language={language}
          >
            {renderBottomAnimation()}
          </SlideAnimation>
        </>
      )}
    </div>
  )
}

const SlideAnimation = ({
  children,
  className,
  bottomHover,
  topHover,
  animationWrapper,
  language,
}) => (
  <div
    className={classNames(
      'absolute flex',
      {
        ['bottom-0 left-0 w-full items-end justify-between']: bottomHover,
        ['left-0 top-0 items-start bg-white gap-1']: topHover,
      },
      className
    )}
  >
    <div
      className={classNames(
        {
          [styles['animated-action-wrapper']]: animationWrapper,
          [styles['arabic-animated-action-wrapper']]:
            animationWrapper && isArabic(language?.code),
        },
        'bg-white relative',
        styles.childrenContainer
      )}
    >
      {children}
    </div>
  </div>
)

export default AnimatedCard
